import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

const textTokens = {
  dark: {
    primary: 'text.primary',
    secondary: 'text.secondary',
  },
  light: {
    primary: 'light.text.primary',
    secondary: 'light.text.secondary',
  },
} as const

export const formContainerStyles = (
  _colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
})

export const formHeaderStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}

export const formTitleStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  fontFamily: "'Soehne Kraftig', sans-serif",
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '28px',
  lineHeight: '36px',
  letterSpacing: '-0.14px',
  color: textTokens[colorScheme].primary,
  margin: 0,
})

export const formDescriptionStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  fontFamily: "'Soehne', sans-serif",
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '24px',
  color: textTokens[colorScheme].secondary,
  margin: 0,
})

export const formBodyStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}

export const formFooterStyles: SystemStyleObject = {
  display: 'flex',
  justifyContent: 'flex-end',
}

export const formSectionStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'row',
  gap: '32px',
  alignItems: 'flex-start',
}

export const formSectionLabelAreaStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flexShrink: '0',
  width: '240px',
}

export const formSectionTitleStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  fontFamily: "'Soehne Kraftig', sans-serif",
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '20px',
  color: textTokens[colorScheme].primary,
  margin: 0,
})

export const formSectionDescriptionStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  fontFamily: "'Soehne', sans-serif",
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '12px',
  lineHeight: '16px',
  color: textTokens[colorScheme].secondary,
  margin: 0,
})

export const formSectionBodyStyles: SystemStyleObject = {
  flex: '1 0 0',
  minWidth: '0',
  alignSelf: 'stretch',
}
